function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "#3E4C57",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M5 8c.033.003.066 0 .1 0A.6.6 0 1 1 5 9.192V9.2H2a.8.8 0 0 0-.8.8v10a.8.8 0 0 0 .8.8h14a.8.8 0 0 0 .8-.8V10a.8.8 0 0 0-.8-.8h-3a.615.615 0 0 1-.5-.6.6.6 0 0 1 .5-.592V8h3a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V10a2 2 0 0 1 2-2h3z"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(6.4)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 1.2,
  height: 10,
  x: 2,
  y: 4,
  rx: 0.6
}), /*#__PURE__*/React.createElement("rect", {
  width: 1.2,
  height: 2,
  x: 2,
  rx: 0.6
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.521 12.941l-1.78 1.78a.2.2 0 0 1-.282 0l-1.78-1.78A.2.2 0 0 1 .82 12.6h3.56a.2.2 0 0 1 .141.341z"
})));

var SvgImport = function SvgImport(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgImport, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/import.e317c157.svg";
export { ForwardRef as ReactComponent };